import { Controller } from "@hotwired/stimulus"

// タグのチップ選択。選択数を表示し、上限に達したら未選択のタグを押せなくする
export default class extends Controller {
  static targets = ["checkbox", "counter"]
  static values = { max: Number }

  connect() {
    this.refresh()
  }

  refresh() {
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked)
    const limitReached = selected.length >= this.maxValue

    this.checkboxTargets.forEach((checkbox) => {
      // 上限到達時、選択済みは解除できるよう有効のままにする
      checkbox.disabled = limitReached && !checkbox.checked

      const chip = checkbox.closest(".tag-chip")
      chip.classList.toggle("tag-chip--selected", checkbox.checked)
      chip.classList.toggle("tag-chip--disabled", checkbox.disabled)
    })

    this.counterTarget.textContent = `${selected.length} / ${this.maxValue} 個選択中`
    this.counterTarget.classList.toggle("tag-picker__counter--full", limitReached)
  }
}
